// libraries
import styled from 'styled-components';

export const StyledWeeklyManpowerCard = styled.div`
  position: relative;
  padding: 14px 20px;
  min-width: 300px;
  width: 300px;
  height: 176px;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    padding: 1px;
    border-radius: 8px;
    background: linear-gradient(
      115.38deg,
      #0dffae -15.48%,
      rgba(13, 255, 174, 0.34) 9.57%,
      rgba(13, 255, 174, 0) 58.82%,
      rgba(13, 255, 174, 0.49) 110.66%,
      #0dffae 146.08%
    );

    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
    z-index: 10;
  }

  > h2 {
    color: var(--color-white) !important;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const StyledContentWrapper = styled.div`
  > canvas {
    height: 116px !important;
  }
`;
